export default __webpack_public_path__ + "static/media/exit-condition.8c4c1f7b.svg";